import {
  Bitmap,
  ButtonBase,
  Container,
  detectDeviceEnvironmentConstants,
  dispatcher,
  getText,
  ingenuity,
  ITween,
  Label,
  Linear,
} from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther";
import { SlotEventConstants } from "@quest/slot-core";

import { BannerScreenView } from "./BannerScreenView";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class BannerScreenController {
  protected view: BannerScreenView;
  protected bannerBottomContainer: Container;
  protected bannerMainContainer: Container;
  protected bannerDetectiveContainer: Container;
  protected bannerWizardContainer: Container;
  protected bannerDetectiveMsgContainer: Container;
  protected bannerWizardMsgContainer: Container;
  private boardButtonContainer: Container;
  protected detectiveMsgText: Label;
  protected wizardMsgText: Label;
  protected displayMsg: string;
  private fullScreenBgAlpha: Bitmap;
  private arrowImage: Bitmap;
  private boardButtonButton: ButtonBase;
  private bannerMsgCounter: number = 1;
  // private building_1_Container: Container;
  // private buildingBgGlow: Bitmap;
  private closeButtonContainer: Container;
  private iconAndProgressContainer: Container;
  // private freeSpinsContainer: Container;
  private closeButton: ButtonBase;
  private detectiveChar: Bitmap;
  private bannerMsgContainer: Container;
  private detectiveApeared: boolean = false;
  // private sceneEndDialouge = [7, 13];
  private sceneEndDialouge: any = [];
  private skipButton: ButtonBase;
  constructor(view: BannerScreenView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvents();
  }

  protected initializeElements(): void {
    this.fullScreenBgAlpha = this.view.getImageById("fullScreenBgAlpha");
    this.bannerMainContainer = this.view.getContainerByID("bannerMainContainer");
    this.bannerBottomContainer = this.view.getContainerByID("bannerBottomContainer");
    this.bannerDetectiveContainer = this.view.getContainerByID("bannerDetectiveContainer");
    this.detectiveChar = this.view.getImageById("detectiveBg");
    this.bannerMsgContainer = this.view.getContainerByID("bannerMsgContainer");
    this.bannerDetectiveMsgContainer = this.view.getContainerByID("bannerDetectiveMsgContainer");
    this.boardButtonContainer = this.view.getContainerByID("boardButtonContainer");
    this.iconAndProgressContainer = this.view.getContainerByID("iconAndProgressContainer");
    this.closeButtonContainer = this.view.getContainerByID("closeButtonContainer");
    this.arrowImage = this.view.getImageById("arrowClose");
    this.detectiveMsgText = this.view.getLabelById("detectiveMsgText") as Label;
    this.closeButton = this.view.getButtonById("closeButton") as ButtonBase;
    this.skipButton = this.view.getButtonById("skipButton") as ButtonBase;
    this.boardButtonButton = this.view.getButtonById("boardStaticImage") as ButtonBase;
    this.boardButtonButton.buttonMode = true;
    this.boardButtonButton.interactive = true;
    this.boardButtonButton.on(ButtonBase.UP, this.onBoardButtonPressedUp, this);
    this.closeButton.on(ButtonBase.UP, this.clickCloseButton, this);
    this.skipButton.on(ButtonBase.UP, this.clickSkipButton, this);
  }

  protected subscribeEvents(): void {
    dispatcher.on(eventDispatchers.DISPLAY_BANNER_SCREEN, this.checkBannerCounter, this);
    dispatcher.on(eventDispatchers.CHECK_RESIZE, this.setHighlightPosition, this)
  }


  protected checkBannerCounter(): void {
    // (ingenuity.soundManager as any).playSound(SoundConstantGame.CHAR_APPEAR, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    this.bannerMsgCounter = (ingenuity.parserModel as GameParserModel).getBannerCounter();
    let localKey: string = "lbl_banner_1_" + this.bannerMsgCounter;
    this.resetMain();
    this.view.addToTop();
    this.skipButton.visible = true;
    this.bannerMainContainer.visible = true;
    this.fullScreenBgAlpha.visible = true;
    this.checkDialougeCounter(this.bannerMsgCounter);
    (ingenuity.parserModel as GameParserModel).setBannerCounter(
      (ingenuity.parserModel as GameParserModel).getBannerCounter() + 1
    );
    if (localKey != getText(localKey)) {
      this.displayMsg = getText(localKey);
      this.playDetectiveScreen();
    }
    this.removestageClick();
  }

  private checkDialougeCounter(counter: number): void {
    if (counter === 5) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.HIGHTLIGHT_1, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      this.showIconAndProgressBar();
    } else if (counter == 6) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.HIGHTLIGHT_2, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      this.hideIconAndProgressBar();
      this.showBoardButton();
    } else if (counter == 7) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.HIGHTLIGHT_1, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      this.boardButtonContainer.visible = false;
      dispatcher.fireEvent(eventDispatchers.SHOW_INVESTINGATION_ROOM);
      dispatcher.fireEvent(eventDispatchers.DISABLE_BOARD_BUTTONS);
      dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
    }
    else if (counter == 8) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.HIGHTLIGHT_3, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      this.highlightClueSection("criminal");
    } else if (counter == 9) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.HIGHTLIGHT_4, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      this.highlightClueSection("location");
    } else if (counter == 10) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.HIGHTLIGHT_5_1, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      this.highlightClueSection("weapon");
    } else if (counter == 11) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.HIGHTLIGHT_5_2, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      this.highlightClueRewardSection();
    } else if (counter == 12) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.HIGHTLIGHT_5_2, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      this.highlightGrandSection();
    } else if (counter == 13) {
      this.showCancelButton();
    } else if (counter === 14) {
      dispatcher.fireEvent(eventDispatchers.HIDE_INVESTINGATION_ROOM);
      this.view.getImageById("closeButtonGlow").visible = false;
      this.view.getContainerByID("closeTapTextCont").visible = false;
      this.arrowImage.visible = false;
      // dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
      // this.checkBannerCounter();
      this.closeButtonContainer.visible = false;

      this.skipButton.on(ButtonBase.DOWN, this.clickSkipButton, this);
      this.skipButton.visible = true;
    }
    else if (counter == 15) {
      this.clickSkipButton();
    }
  }

  private resetMain(): void {
    this.boardButtonContainer.visible = false;
    this.iconAndProgressContainer.visible = false;

    this.detectiveChar.x = this.detectiveChar.json.x;
    this.detectiveChar.y = this.detectiveChar.json.y;
    this.bannerMsgContainer.x = this.bannerMsgContainer.json.x;
    this.bannerMsgContainer.y = this.bannerMsgContainer.json.y;
    this.boardButtonContainer.visible = false;
    this.iconAndProgressContainer.visible = false;
    this.view.getContainerByID("criminalSection").visible = false;
    this.view.getContainerByID("locationSection").visible = false;
    this.view.getContainerByID("weaponSection").visible = false;
    this.view.getContainerByID("frameContainer").visible = false;
    this.view.getContainerByID("rewardClueBoxCont").visible = false;
  }

  private showBoardButton(): void {
    this.bannerBottomContainer.visible = false;
    this.boardButtonContainer.visible = true;

    // this.removestageClick();
  }

  private showIconAndProgressBar(): void {
    this.iconAndProgressContainer.visible = true;
  }
  private hideIconAndProgressBar(): void {
    this.iconAndProgressContainer.visible = false;
  }

  private showCancelButton(): void {
    this.skipButton.off(ButtonBase.DOWN, this.clickSkipButton, this);
    this.skipButton.visible = false;
    this.closeButtonContainer.visible = true;
    this.view.getImageById("closeButtonGlow").visible = true;
    this.view.getContainerByID("closeTapTextCont").visible = true;
    this.arrowImage.visible = true;
    this.bannerBottomContainer.visible = false;
    dispatcher.fireEvent(eventDispatchers.DISABLE_BOARD_BUTTONS);
    // this.removestageClick();
  }

  private clickCloseButton(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.COMMON_CLICK_SOUND, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });

    dispatcher.fireEvent(eventDispatchers.HIDE_INVESTINGATION_ROOM);
    this.view.getImageById("closeButtonGlow").visible = false;
    this.view.getContainerByID("closeTapTextCont").visible = false;
    this.arrowImage.visible = false;
    dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
    this.checkBannerCounter();
    this.closeButtonContainer.visible = false;
  }
  private clickSkipButton(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.COMMON_CLICK_SOUND, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });

    this.removestageClick()
    if (this.bannerMsgCounter > 7 && this.bannerMsgCounter < 13) {
      dispatcher.fireEvent(eventDispatchers.HIDE_INVESTINGATION_ROOM);
    }
    if (this.bannerMsgCounter === 13) return;
    dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
    this.hideBannerView();
    this.resetContainers();

  }


  private setHighlightPosition() {
    const detectiveMsgText = this.view.getLabelById("detectiveMsgText");
    let category: string;
    category = this.bannerMsgCounter === 8 ? "criminal"
      : this.bannerMsgCounter === 9 ? "location"
        : this.bannerMsgCounter === 10 ? "weapon"
          : "";
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      if (category) {
        if (category === 'criminal') {
          detectiveMsgText.x = detectiveMsgText.json.criminalHighlightPortraitX;
        } else {
          detectiveMsgText.x = detectiveMsgText.json.x;
        }
        this.detectiveChar.x = this.detectiveChar.json[`${category}HighlightPortraitX`];
        this.detectiveChar.y = this.detectiveChar.json[`${category}HighlightPortraitY`];
        this.bannerMsgContainer.x = this.bannerMsgContainer.json[`${category}HighlightPortraitX`];
        this.bannerMsgContainer.y = this.bannerMsgContainer.json[`${category}HighlightPortraitY`];
      } else {
        if (this.bannerMsgCounter == 11 || this.bannerMsgCounter == 12) {
          this.detectiveChar.x = this.detectiveChar.json.grandFramePortraitX;
          this.detectiveChar.y = this.detectiveChar.json.grandFramePortraitY;
          this.bannerMsgContainer.x = this.bannerMsgContainer.json.grandFramePortraitX;
          this.bannerMsgContainer.y = this.bannerMsgContainer.json.grandFramePortraitY;
        }
      }
    } else {
      if (category) {
        if (category === 'criminal') {
          detectiveMsgText.x = detectiveMsgText.json.criminalHighlightX;
        } else {
          detectiveMsgText.x = detectiveMsgText.json.x;
        }
        this.detectiveChar.x = this.detectiveChar.json[`${category}HighlightX`];
        this.detectiveChar.y = this.detectiveChar.json[`${category}HighlightY`];
        this.bannerMsgContainer.x = this.bannerMsgContainer.json[`${category}HighlightX`];
        this.bannerMsgContainer.y = this.bannerMsgContainer.json[`${category}HighlightY`];
      } else {

        if (this.bannerMsgCounter == 11 || this.bannerMsgCounter == 12) {
          this.detectiveChar.x = this.detectiveChar.json.grandFrameX;
          this.detectiveChar.y = this.detectiveChar.json.y;
          this.bannerMsgContainer.x = this.bannerMsgContainer.json.grandFrameX;
          this.bannerMsgContainer.y = this.bannerMsgContainer.json.grandFrameY;
        }

      }
    }
  }
  protected highlightClueSection(category: string): void {
    const detectiveMsgText = this.view.getLabelById("detectiveMsgText");
    this.setHighlightPosition();
    if (category === "criminal") {
      this.bannerMsgContainer.scale.set(-1, 1);
      detectiveMsgText.scale.set(-1, 1);
    } else {
      this.bannerMsgContainer.scale.set(1, 1);
      detectiveMsgText.scale.set(1, 1);
    }
    this.view.getContainerByID(`${category}Section`).visible = true;
  }
  protected highlightGrandSection(): void {
    this.setHighlightPosition();
    this.view.getContainerByID("frameContainer").visible = true;
  }
  protected highlightClueRewardSection(): void {
    // this.setHighlightPosition();
    this.detectiveChar.x = this.detectiveChar.json.grandFrameX;
    this.view.getContainerByID("rewardClueBoxCont").visible = true;
  }

  private hideBannerView(): void {
    this.view.visible = false;
  }

  private onBoardButtonPressedUp(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.COMMON_CLICK_SOUND, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });

    this.checkBannerCounter();
    this.boardButtonContainer.visible = false;
    dispatcher.fireEvent(eventDispatchers.SHOW_INVESTINGATION_ROOM);
    dispatcher.fireEvent(eventDispatchers.DISABLE_BOARD_BUTTONS);
    dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
  }

  protected playDetectiveScreen(): void {
    !this.detectiveApeared &&
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
        id: SoundConstantGame.CHAR_APPEAR,
        vol: 0.8,
        loop: false,
        key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
      });
    this.detectiveApeared = true;

    if (this.bannerDetectiveContainer.visible) {
      this.changeDetectiveMsgDialoge();
      return;
    }
    this.playDetectiveScreenTween();
  }

  protected playDetectiveScreenTween(): void {
    this.bannerDetectiveContainer.alpha = 0;
    let banneerTween: ITween;
    banneerTween = ingenuity.currentGame.add
      .tween(this.bannerDetectiveContainer)
      .to({ alpha: 1 }, 250, Linear.None, true, 0);
    banneerTween.onComplete.addOnce(() => {
      banneerTween.stop();
      this.bannerDetectiveContainer.visible = true;
      this.changeDetectiveMsgDialoge();
      ingenuity.currentGame.tweens.remove(banneerTween);
    });
  }

  protected changeDetectiveMsgDialoge(): void {
     dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
      id: SoundConstantGame.DIALOGUE_CLOUD_SOUND,
      vol: 0.8,
      loop: false,
      key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
    });
    if (this.bannerDetectiveMsgContainer.visible) {
      this.bannerDetectiveMsgContainer.scale.set(1);
      let banneerTweenMsgOut: ITween;
      banneerTweenMsgOut = ingenuity.currentGame.add
        .tween(this.bannerDetectiveMsgContainer.scale)
        .to({ x: 0, y: 0 }, 250, Linear.None, true, 0);
      banneerTweenMsgOut.onComplete.addOnce(() => {
        banneerTweenMsgOut.stop();
        this.detectiveMsgText.setText(this.displayMsg);
        ingenuity.currentGame.tweens.remove(banneerTweenMsgOut);
        let banneerTweenMsgIn: ITween;
        banneerTweenMsgIn = ingenuity.currentGame.add
          .tween(this.bannerDetectiveMsgContainer.scale)
          .to({ x: 1, y: 1 }, 250, Linear.None, true, 0);
        banneerTweenMsgIn.onComplete.addOnce(() => {
          banneerTweenMsgIn.stop();
          ingenuity.currentGame.tweens.remove(banneerTweenMsgIn);
          if (!this.sceneEndDialouge.includes((ingenuity.parserModel as GameParserModel).getBannerCounter())) {
            this.addstageClick();

          }
        });
      });
    } else {
      this.bannerDetectiveMsgContainer.visible = true;
      this.bannerDetectiveMsgContainer.scale.set(0);
      this.detectiveMsgText.setText(this.displayMsg);
      let banneerTweenMsgIn: ITween;
      banneerTweenMsgIn = ingenuity.currentGame.add
        .tween(this.bannerDetectiveMsgContainer.scale)
        .to({ x: 1, y: 1 }, 250, Linear.None, true, 0);
      banneerTweenMsgIn.onComplete.addOnce(() => {
        banneerTweenMsgIn.stop();
        ingenuity.currentGame.tweens.remove(banneerTweenMsgIn);
        if (!this.sceneEndDialouge.includes((ingenuity.parserModel as GameParserModel).getBannerCounter())) {
          this.addstageClick();
        }
      });
    }
    this.bannerBottomContainer.visible = true;
  }

  protected addstageClick(): void {
    //  this.bannerBottomContainer.visible = true;
    if (this.bannerDetectiveMsgContainer.visible) {

      ingenuity.currentGame.input.onDown.add(this.checkBannerCounter, this);
    }
  }

  protected removestageClick(): void {
    // this.bannerBottomContainer.visible = false;
    ingenuity.currentGame.input.onDown.remove(this.checkBannerCounter, this);
  }

  private resetContainers(): void {
    this.removestageClick()
    this.boardButtonContainer.visible = false;
    this.bannerMsgCounter = 1;
    this.bannerDetectiveMsgContainer.visible = false;
    this.bannerDetectiveContainer.visible = false;
    this.bannerDetectiveMsgContainer.alpha = 1;
  }
}
